import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { TrendingUp, Loader2, Edit, Save } from 'lucide-react';

export const BiginDealDialog = ({ availablePipelines, dealForm, editingItem, saveDeal, saving, setDealForm, setShowDealDialog, showDealDialog }) => (
      <Dialog open={showDealDialog} onOpenChange={setShowDealDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-orange-600" />
              {editingItem ? 'Edit Deal' : 'Add New Deal'}
            </DialogTitle>
            <DialogDescription>
              {editingItem ? 'Update deal details in Zoho Bigin' : 'Create a new deal in Zoho Bigin pipeline'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Deal Name *</Label>
              <Input 
                value={dealForm.name}
                onChange={(e) => setDealForm({...dealForm, name: e.target.value})}
                placeholder="Patient Treatment - John Doe"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Pipeline</Label>
                <Select value={dealForm.pipeline} onValueChange={(v) => setDealForm({...dealForm, pipeline: v})}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {availablePipelines.map((pipeline) => (
                      <SelectItem key={pipeline} value={pipeline}>{pipeline}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label>Stage</Label>
                <Select value={dealForm.stage} onValueChange={(v) => setDealForm({...dealForm, stage: v})}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Inquiry">Inquiry</SelectItem>
                    <SelectItem value="Qualification">Qualification</SelectItem>
                    <SelectItem value="Needs Analysis">Needs Analysis</SelectItem>
                    <SelectItem value="Proposal">Proposal</SelectItem>
                    <SelectItem value="Negotiation">Negotiation</SelectItem>
                    <SelectItem value="Closed Won">Closed Won</SelectItem>
                    <SelectItem value="Closed Lost">Closed Lost</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Amount (INR)</Label>
                <Input 
                  type="number"
                  value={dealForm.amount}
                  onChange={(e) => setDealForm({...dealForm, amount: e.target.value})}
                  placeholder="100000"
                />
              </div>
              <div className="space-y-2">
                <Label>Closing Date</Label>
                <Input 
                  type="date"
                  value={dealForm.closing_date}
                  onChange={(e) => setDealForm({...dealForm, closing_date: e.target.value})}
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Description</Label>
              <Textarea 
                value={dealForm.description}
                onChange={(e) => setDealForm({...dealForm, description: e.target.value})}
                placeholder="Deal details..."
                rows={3}
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDealDialog(false)}>Cancel</Button>
            <Button onClick={saveDeal} disabled={saving} className="bg-orange-600 hover:bg-orange-700">
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
              {editingItem ? 'Update' : 'Create'} in Bigin
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
);
